import { render, staticRenderFns } from "./whatsapp.vue?vue&type=template&id=2d2ced2a&scoped=true"
import script from "./whatsapp.vue?vue&type=script&lang=js"
export * from "./whatsapp.vue?vue&type=script&lang=js"
import style0 from "./whatsapp.vue?vue&type=style&index=0&id=2d2ced2a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2ced2a",
  null
  
)

export default component.exports